import type { GroupSearchHeaderFirstRowContentProps } from './components/GroupSearchHeaderFirstRowContent';
import type { GroupFolderScopePickerProps } from './components/GroupFolderScopePicker';
import type { RefAttributes } from 'react';
import type { SearchBoxContainerHandle } from 'owa-search';
import type * as lazyIndex from './lazyIndex';
import { createLazyComponent, type LazyComponent, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "GroupsSearchView"*/ './lazyIndex'),
    { name: 'GroupsSearchView' }
);

// Export delay loaded components
export const GroupSearchBoxContainer: LazyComponent<
    Omit<RefAttributes<SearchBoxContainerHandle>, 'ref'> & RefAttributes<SearchBoxContainerHandle>,
    SearchBoxContainerHandle,
    void
> = createLazyComponent(lazyModule, m => m.GroupSearchBoxContainer);
export const GroupFolderScopePicker: LazyComponent<GroupFolderScopePickerProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.GroupFolderScopePicker);
export const GroupSearchHeaderFirstRowContent: LazyComponent<
    GroupSearchHeaderFirstRowContentProps,
    unknown,
    void
> = createLazyComponent(lazyModule, m => m.GroupSearchHeaderFirstRowContent);
